import { render, staticRenderFns } from "./CompareItem.vue?vue&type=template&id=4cbae4c2&"
import script from "./CompareItem.vue?vue&type=script&lang=js&"
export * from "./CompareItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareItem.vue?vue&type=style&index=0&id=4cbae4c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports